export default [
    [
        "A",
        "A",
        "A"
    ],
    [
        "A",
        "B",
        "A",
        "B",
        "C",
        "B"
    ],
    [
        "A",
        "B",
        "C",
        "A",
        "B",
        "C",
        "D",
        "C"
    ],
    [
        "A",
        "A",
        "B",
        "A"
    ],
    [
        "A",
        "B",
        "A",
        "B"
    ],
    [
        "A",
        "B",
        "C",
        "A",
        "B",
        "C",
        "D",
        "B",
        "C"
    ],
    [
        "A",
        "B",
        "A",
        "C",
        "A",
        "B",
        "A"
    ]
]